export const contact = {
  clubName: "Redland Golf & Country Club",
  addressLine1: "24451 SW 177th Ave",
  cityStateZip: "Homestead, FL 33031",
  fullAddress: "24451 SW 177th Ave, Homestead, FL 33031, USA",
  phoneDisplay: "305-247-8503",
  phoneHref: "tel:+13052478503",
  email: "redlandgolfcc@aol.com",
  emailHref: "mailto:redlandgolfcc@aol.com",
  proShopExtension: "Extension 1",
  campExtension: "Extension 3",
  sandTrapExtension: "Extension 4",
  timTronzoMobileDisplay: "954-531-5468",
  timTronzoMobileHref: "tel:+19545315468",
  directionsHref:
    "https://www.google.com/maps/search/?api=1&query=24451%20SW%20177th%20Ave%2C%20Homestead%2C%20FL%2033031%2C%20USA",
  mapEmbedSrc:
    "https://www.google.com/maps?q=24451%20SW%20177th%20Ave%2C%20Homestead%2C%20FL%2033031%2C%20USA&output=embed",
  googleRating: "4.3 rating based on 354 reviews",
};

export const booking = {
  label: "Book a Tee Time",
  href: "/book",
  widgetUrl: "https://www.chronogolf.com/club/19620/widget?medium=widget&source=club",
  clubId: 19620,
  note: "Book tee times online through Lightspeed Golf.",
};

export const siteImages = {
  heroFairway: {
    src: "/images/redland-local/aerial-clubhouse.jpg",
    alt: "Aerial view of Redland Golf and Country Club, the clubhouse, pond, fairways, and practice range.",
  },
  palmCourse: {
    src: "/images/redland-local/pond-fairway.jpg",
    alt: "Aerial view of a Redland Golf pond, palm tree, and fairway.",
  },
  golfCart: {
    src: "/images/redland-local/range-bays.jpg",
    alt: "Covered practice bays looking out across the Redland Golf driving range.",
  },
  clubhouse: {
    src: "/images/redland-local/clubhouse.jpg",
    alt: "Redland Golf clubhouse entrance with the awning and parking area.",
  },
  dining: {
    src: "/images/redland-dining.jpg",
    alt: "Outdoor restaurant patio with dining tables, chairs, and warm hospitality details.",
  },
  junior: {
    src: "/images/redland-junior.jpg",
    alt: "Young golfer holding a club during a sunny practice session.",
  },
  rangeWide: {
    src: "/images/redland-local/flag-fairway.jpg",
    alt: "Redland Golf fairway and yellow flag beneath a wide cloud-filled sky.",
  },
  golfDetail: {
    src: "/images/redland-local/tee-marker.jpg",
    alt: "Close-up of a tee marker on the Redland Golf practice turf.",
  },
};

export const navItems = [
  { label: "Home", href: "/" },
  { label: "About Us", href: "/about-us" },
  { label: "Rates", href: "/rates" },
  { label: "Memberships", href: "/memberships" },
  { label: "Golf Events", href: "/golf-events" },
  { label: "Banquets", href: "/banquets" },
  {
    label: "Junior",
    children: [
      { label: "Junior Golf", href: "/junior-golf" },
      { label: "Junior Camp", href: "/junior-camp" },
    ],
  },
  { label: "The Sand Trap", href: "/the-sand-trap" },
  { label: "Contact Us", href: "/contact-us" },
];

export const footerLinks = [
  { label: "Rates", href: "/rates" },
  { label: "Memberships", href: "/memberships" },
  { label: "Golf Events", href: "/golf-events" },
  { label: "Banquets", href: "/banquets" },
  { label: "Junior Golf", href: "/junior-golf" },
  { label: "Junior Camp", href: "/junior-camp" },
  { label: "The Sand Trap", href: "/the-sand-trap" },
  { label: "Contact Us", href: "/contact-us" },
];

export const homeContent = {
  hero: {
    eyebrow: "Serving South Florida Since 1947",
    title: "Your Home Course in the Heart of Redland",
    copy:
      "Experience approachable golf, scenic fairways, and a welcoming South Florida community just outside Homestead.",
  },
  quickFacts: [
    "18-Hole Course",
    "Open to the Public",
    "Homestead, Florida",
    "Call 305-247-8503",
  ],
  quickActions: [
    {
      label: "Book a Tee Time",
      href: booking.href,
      detail: "Reserve online through the Chronogolf tee time widget.",
    },
    {
      label: "View Current Rates",
      href: "/rates",
      detail: "Weekday, weekend, twilight, range, and fee details.",
    },
    {
      label: "Explore Memberships",
      href: "/memberships",
      detail: "Golf, junior, social, family, and winter options.",
    },
    {
      label: "Plan an Event",
      href: "/golf-events",
      detail: "Tournaments, leagues, clinics, and club activities.",
    },
  ],
  aboutPreview: {
    title: "Southern Florida Golf at Its Best",
    copy:
      "Discover the charm of Redland Golf, where the beauty of Southern Florida meets world-class golfing. Surrounded by lush landscapes and warm sunshine year-round, our course offers the perfect blend of challenge and relaxation for players of all levels.",
  },
  membershipPreview: {
    title: "Join Our Membership",
    copy:
      "Become part of the Redland Golf community and enjoy more of what you love. Our memberships offer exclusive access to the course, special events, and member-only perks that make every visit more rewarding.",
  },
  eventsPreview: {
    title: "Upcoming Events",
    copy:
      "There is always something happening at Redland Golf. From exciting tournaments and member mixers to seasonal celebrations and family-friendly gatherings, our calendar is filled with opportunities to play, connect, and unwind.",
  },
  juniorPreview: {
    title: "Redland Junior Golf",
    copy:
      "Impacting the lives of young people by providing education programs that build character, instill life-enhancing values, and promote healthy choices through the game of golf.",
  },
  finalCta: {
    title: "Ready for Your Next Round?",
    actions: ["Call the Pro Shop", "Book a Tee Time", "View Rates"],
  },
  lifeAtRedland: [
    { label: "Aerial clubhouse", src: siteImages.heroFairway.src, alt: siteImages.heroFairway.alt },
    { label: "Waterfront fairway", src: siteImages.palmCourse.src, alt: siteImages.palmCourse.alt },
    { label: "Covered practice bays", src: siteImages.golfCart.src, alt: siteImages.golfCart.alt },
    { label: "Clubhouse arrival", src: siteImages.clubhouse.src, alt: siteImages.clubhouse.alt },
  ],
};

export const aboutContent = {
  title: "About Redland Golf",
  body:
    "Opened in 1947 just outside of Homestead, Redland Golf & Country Club is the place to be for a beautiful, 18-hole round of Florida golf. Our club features a full-service pro shop, full banquet facility, restaurant, Ladies' and Men's Leagues, and so much more.\n\nWe are the proud home of The Homestead Amateur Golf Classic and Redland Junior Golf. Come visit our course today and see for yourself the magic that is Redland Golf & Country Club.",
  features: [
    "Opened in 1947",
    "18-Hole Golf Course",
    "Full-Service Pro Shop",
    "Banquet Facility",
    "Restaurant",
    "Ladies' and Men's Leagues",
    "Home of the Homestead Amateur Golf Classic",
    "Redland Junior Golf",
  ],
};

export const rateNotices = [
  "All rates include cart and sales tax.",
  "Prices are subject to change without notice.",
  "Nine-hole guest rates have been eliminated.",
  "Holiday rates apply on listed holidays.",
];

export const rates = {
  weekday: [
    { label: "8:00 AM-11:59 AM", price: "$65" },
    { label: "12:00 PM-3:59 PM", price: "$50" },
    { label: "4:00 PM-7:00 PM", price: "$40" },
    { label: "First Responders, Monday through Thursday", price: "$50" },
  ],
  weekend: [
    { label: "8:00 AM-11:59 AM", price: "$90" },
    { label: "12:00 PM-3:59 PM", price: "$65" },
    { label: "4:00 PM-7:00 PM", price: "$45" },
    { label: "First Responder rate", price: "Not available" },
  ],
  holidayRatesApplyOn: [
    "New Year's Day",
    "Martin Luther King Jr. Day",
    "Presidents' Day",
    "Memorial Day",
    "Fourth of July",
    "Labor Day",
    "Columbus Day",
    "Veterans Day",
    "Thanksgiving Day",
    "Thanksgiving Weekend, Friday through Sunday",
    "Christmas Eve",
    "New Year's Eve",
  ],
  holidayNotices: [
    "Thanksgiving Day: Closes early. Call the Pro Shop for available tee times.",
    "Christmas Eve: Closes early. Call the Pro Shop for available tee times.",
    "Closed Christmas Day.",
  ],
  additionalFees: [
    { label: "Rider Fee", price: "$15 per person" },
    { label: "Spectator Fee", price: "$25 per person" },
  ],
  rangeBalls: [
    { label: "Small Basket", price: "$5" },
    { label: "Medium Basket", price: "$10" },
    { label: "Large Basket", price: "$15" },
  ],
  firstResponderDays: ["Monday", "Tuesday", "Wednesday", "Thursday"],
  firstResponderIncludes: [
    "Green fees",
    "Cart",
    "Choice of one Budweiser draft beer, brewed tea, or fountain soda",
    "Small bucket of range balls",
  ],
};

export const winterHours = {
  effectiveDate: "Effective Monday, November 13, 2023",
  notice: "Event nights may have extended hours.",
  sandTrapPhone: "305-247-8503, extension 4.",
  rows: [
    { day: "Monday-Thursday", kitchen: "7:30 AM-7:30 PM", sandTrap: "7:00 AM-9:00 PM" },
    { day: "Friday", breakfast: "Breakfast ends at 11:00 AM", kitchen: "7:30 AM-8:00 PM", sandTrap: "7:00 AM-9:00 PM" },
    { day: "Saturday", breakfast: "Breakfast ends at 12:00 PM", kitchen: "6:30 AM-8:00 PM", sandTrap: "6:30 AM-9:00 PM" },
    { day: "Sunday", breakfast: "Breakfast ends at 12:00 PM", kitchen: "6:30 AM-7:00 PM", sandTrap: "6:30 AM-8:00 PM" },
  ],
};

export const dressCode = [
  "Golf attire required",
  "No T-shirts",
  "No jeans",
  "No denim shorts",
  "Collared shirt required",
];

export const giftCardPolicy =
  "We do not accept gift cards purchased through goplaygolf.com. Redland Golf & Country Club is not enrolled in their gift card program. We only accept Redland Golf & Country Club in-house gift certificates, which are available in the Pro Shop.";

export const memberships = {
  title: "Join the RGCC Family",
  intro: [
    "Our members are our greatest asset. The vast majority of the warm and friendly membership here at Redland Golf & Country Club have been here practically all their lives. This creates a comforting sense of community and belonging for all who join.",
    "We are always looking for positive new people to add to our happy extended family surrounding the great game of golf. There are many weekly events where you can find a partner, as well as clinics and junior programs to enjoy.",
    "If you love this sport as much as we do and would enjoy playing and socializing with some of the finest and friendliest people that South Florida has to offer, consider making it official by becoming a member.",
  ],
  benefits: [
    "10% discount on food and beverages in the restaurant",
    "Voting privileges",
    "Free range balls",
    "Participation in club tournaments",
    "GHIN Handicap",
    "Members pay cart fees only",
    "Nine-hole cart fee: $15",
    "Eighteen-hole cart fee: $30",
    "Member charging is not permitted",
    "One free bag storage with family membership",
  ],
  annualPaymentNote: "Annual payments include a 5% discount.",
  pricing: [
    { name: "Family Membership", description: "Includes children under 18 and one free bag storage.", monthly: "$282.48 per month", yearly: "$3,220.27 per year" },
    { name: "Single Golf Membership, Age 36 and Older", monthly: "$205.98 per month", yearly: "$2,348.17 per year" },
    { name: "Single Golf Membership, Ages 26-35", monthly: "$147.13 per month", yearly: "$1,677.28 per year" },
    { name: "Single Golf Membership, Ages 19-25", monthly: "$88.28 per month", yearly: "$1,006.39 per year" },
    { name: "Junior Membership, Age 18 and Under", description: "Paid three months at a time.", monthly: "$58.85 per month", yearly: "$670.89 per year" },
    { name: "Social Membership, Per Person", monthly: "$88.28 per month", yearly: "$1,006.39 per year" },
  ],
  winter: {
    requirements: [
      "Minimum three-month membership",
      "Six-month season runs November 1 through May 3",
      "Applicant must reside outside Miami-Dade, Broward, and Monroe Counties",
    ],
    familyPricing: [
      { label: "Three months", price: "$1,160" },
      { label: "Six months", price: "$1,995.34" },
    ],
    singlePricing: "Single winter membership pricing: Contact the club for current details.",
  },
  initiationFee:
    "A one-time, non-refundable initiation fee of $535, including tax, is required for all memberships. The initiation fee may be paid in full or in four installment payments of $133.75 during the first four months of membership. Junior Golf Membership is excluded from the initiation fee.",
  socialConditions: [
    "10% discount on food and beverages only",
    "No golf discount",
    "Guest rates apply to golf fees and carts",
  ],
  importantNotes: [
    "Redland Golf & Country Club is open to the public.",
    "Only members may walk the course.",
    "A collared shirt is required.",
    "Member charging is not permitted.",
  ],
};

export const golfEvents = {
  title: "Golf Events & Activities",
  intro:
    "Whether it is your way of working out stress, enjoying a day with friends, or completing a business deal, we know the importance that a good round of golf can have on your life.\n\nThat is why Redland Golf & Country Club is proud to have been serving great golf and hospitality since 1947.",
  giftCardNotice: "We do not accept gift cards purchased through goplaygolf.com.",
  winners: [
    { title: "Club Champion", name: "Sammy Martinez" },
    { title: "Flight A Winner", name: "Mike Rentz" },
    { title: "Flight B Winner", name: "Jimmy Hughes" },
  ],
  events: [
    { id: "evt-uskids", title: "US Kids Tournament", date: "March 9", description: "", location: "", link: "/golf-events", image: null, startDate: "", endDate: "", startTime: "", expirationDate: "", featured: true, visible: true, order: 0 },
    { id: "evt-fsga", title: "FSGA Tournament", date: "March 29 and March 30", description: "", location: "", link: "/golf-events", image: null, startDate: "", endDate: "", startTime: "", expirationDate: "", featured: true, visible: true, order: 1 },
    { id: "evt-ladies", title: "Fore the Ladies", date: "Wednesdays at 9:30 AM", description: "The Ladies League plays Wednesdays at 9:30 AM from November through April.", location: "", link: "/golf-events", image: null, startDate: "", endDate: "", startTime: "", expirationDate: "", featured: true, visible: true, order: 2 },
    { id: "evt-dogfight", title: "Dogfight", date: "Tuesdays and Fridays", description: "", location: "", link: "/golf-events", image: null, startDate: "", endDate: "", startTime: "", expirationDate: "", featured: false, visible: true, order: 3 },
    { id: "evt-twilight", title: "Twilight Tee Times", date: "", description: "Save money on your game with Redland Golf's twilight rates.", location: "", link: "/golf-events", image: null, startDate: "", endDate: "", startTime: "", expirationDate: "", featured: false, visible: true, order: 4 },
  ],
  clinic: {
    title: "Redland Junior Golf Clinic",
    details: [
      "Every Wednesday, weather permitting",
      "Excludes holidays",
      "4:00 PM-5:30 PM",
      "Space is limited",
      "Call the Pro Shop for details",
      "305-247-8503, extension 1",
    ],
  },
  proShop: [
    "Visit the Pro Shop for current gear.",
    "Club rental is available for $50 plus tax per set.",
  ],
  checkBack: "Check back periodically for updates.",
};

export const juniorGolf = {
  title: "Junior Golf",
  status: "Check back for upcoming events!",
  gallery: [
    { label: "Junior golfer practicing", alt: siteImages.junior.alt, src: siteImages.junior.src },
    { label: "Practice tee detail", alt: siteImages.golfDetail.alt, src: siteImages.golfDetail.src },
    { label: "Learning on the course", alt: siteImages.palmCourse.alt, src: siteImages.palmCourse.src },
  ],
};

export const juniorCamp = {
  title: "Junior Camp",
  mission:
    "Our mission is to impact the lives of young people by providing educational programs that build character, instill life-enhancing values, and promote healthy choices through the game of golf.",
  components: [
    "Golf instruction",
    "On-course instruction",
    "Rules and etiquette",
    "Healthy habits",
    "Core values and life skills",
    "Golf-specific fitness",
    "Games and sports",
  ],
  coreValues: [
    "Sportsmanship",
    "Honesty",
    "Integrity",
    "Respect",
    "Judgment",
    "Confidence",
    "Perseverance",
    "Courtesy",
    "Responsibility",
  ],
  details: [
    { label: "Ages", value: "For children ages 5-16" },
    { label: "Program Director", value: "Dave Vihlen, PGA Teaching Professional" },
    { label: "Program dates", value: "June 8, 2026-July 31, 2026" },
    { label: "Monday-Thursday", value: "9:00 AM-3:00 PM" },
    { label: "Friday", value: "9:00 AM-12:00 PM" },
    { label: "Standard cost", value: "$250 per week (Military, First Responder, and Redland Club Member 10% off)" },
  ],
  forms: [
    { label: "Participation Permission Form", href: null },
    { label: "Registration Form", href: null },
  ],
  registrationInstructions:
    "To register, please complete the participation permission form and registration form, then email the completed forms to redlandgolfcc@aol.com.",
  contactName: "Tim Tronzo",
};

export const sandTrap = {
  title: "The Sand Trap",
  subtitle: "Kitchen at Redland Golf & Country Club",
  intro:
    "At Redland Golf, every meal is an opportunity to enjoy fresh flavors and warm hospitality.\n\nStart your morning with classic breakfast favorites or lighter, energizing options, then stop by at midday for a variety of satisfying sandwiches, salads, and wraps, perfect for a quick bite or a leisurely lunch with friends.\n\nAs the sun sets, our dinner menu offers something for everyone, from savory comfort foods to seasonal specialties, making Redland Golf the ideal place to gather and enjoy breakfast, lunch, and dinner throughout the week.",
  menuGallery: [
    { label: "Breakfast Menu", alt: "The Sand Trap breakfast menu with specialties, omelettes, sandwiches, griddle items, egg choices, and sides.", src: "/images/sand-trap-menu/breakfast-menu.png" },
    { label: "Lunch / Dinner Menu", alt: "The Sand Trap lunch and dinner menu with appetizers, wings, baskets, soups, kids menu, and burgers.", src: "/images/sand-trap-menu/lunch-dinner-menu.png" },
    { label: "Sandwiches & Wraps Menu", alt: "The Sand Trap sandwiches, wraps, salads, and sides menu.", src: "/images/sand-trap-menu/sandwiches-wraps-menu.png" },
  ],
};

export const banquets = {
  title: "Banquets at Redland Golf",
  description:
    "Explore our banquet spaces and see how Redland Golf & Country Club can provide the perfect setting for your next celebration or special event.",
  // Landscape photos (top grid).
  gallery: [
    { alt: "Redland Golf banquet hall set with long tables and black chiavari chairs", src: "/images/banquets/banquet-1.jpg", file: "/images/banquets/banquet-1.jpg" },
    { alt: "Round banquet table with a lavender runner and butterfly place settings", src: "/images/banquets/banquet-2.jpg", file: "/images/banquets/banquet-2.jpg" },
    { alt: "Banquet room with a floral butterfly backdrop and decorated tables", src: "/images/banquets/banquet-3.jpg", file: "/images/banquets/banquet-3.jpg" },
    { alt: "Round banquet table with tropical centerpiece and black charger plates", src: "/images/banquets/banquet-4.jpg", file: "/images/banquets/banquet-4.jpg" },
  ],
  // Portrait photos (bottom grid) — run vertically / slightly longer.
  // To add later: drop files in /app/frontend/public/images/banquets/ then set `src` to the `file` path.
  portraitGallery: [
    { alt: "Redland Golf banquet hall set for a wedding with draped backdrop and chandelier", src: "/images/banquets/banquet-5.jpg", file: "/images/banquets/banquet-5.jpg" },
    { alt: "Redland Golf banquet hall with round tables and black chair covers", src: "/images/banquets/banquet-6.jpg", file: "/images/banquets/banquet-6.jpg" },
  ],
};

export const homepage = {
  hero: {
    visible: true,
    eyebrow: homeContent.hero.eyebrow,
    title: homeContent.hero.title,
    copy: homeContent.hero.copy,
    image: { src: siteImages.heroFairway.src, alt: siteImages.heroFairway.alt },
    facts: [...homeContent.quickFacts],
    buttons: [
      { label: "Book a Tee Time", href: booking.href, variant: "primary" },
      { label: "View Current Rates", href: "/rates", variant: "secondary" },
    ],
  },
  quickActions: {
    visible: true,
    items: homeContent.quickActions.map((a) => ({ ...a })),
  },
  video: {
    visible: true,
    eyebrow: "Course Preview",
    title: "Experience Redland Golf",
    copy:
      "Take a closer look at the course, clubhouse, practice areas, and South Florida setting that make Redland Golf a welcoming place to play.",
    embedUrl: "https://www.youtube-nocookie.com/embed/dHBuXkdd4zU?rel=0",
  },
  about: {
    visible: true,
    eyebrow: "About",
    title: homeContent.aboutPreview.title,
    copy: homeContent.aboutPreview.copy,
    photoLabel: "Approachable public golf just outside Homestead.",
    image: { src: siteImages.palmCourse.src, alt: siteImages.palmCourse.alt },
    buttonLabel: "About Us",
    buttonHref: "/about-us",
  },
  rates: {
    visible: true,
    eyebrow: "Current Rates",
    title: "Plan Your Round",
    copy:
      "A quick look at common public rates. Visit the rates page for holidays, additional fees, range balls, and policy details.",
    buttonLabel: "View Current Rates",
    buttonHref: "/rates",
  },
  membership: {
    visible: true,
    eyebrow: "Membership",
    title: homeContent.membershipPreview.title,
    copy: homeContent.membershipPreview.copy,
    buttonLabel: "Explore Memberships",
    buttonHref: "/memberships",
    image: { src: siteImages.golfCart.src, alt: siteImages.golfCart.alt },
  },
  events: {
    visible: true,
    eyebrow: "Events",
    title: homeContent.eventsPreview.title,
    copy: homeContent.eventsPreview.copy,
  },
  junior: {
    visible: true,
    eyebrow: "Families",
    title: homeContent.juniorPreview.title,
    copy: homeContent.juniorPreview.copy,
    exploreLabel: "Explore Junior Golf",
    exploreHref: "/junior-golf",
    campLabel: "View Junior Camp",
    campHref: "/junior-camp",
    cardTitle: "Junior Camp",
    cardLine1: "For children ages 5-16",
    cardLine2: "June 8, 2026-July 31, 2026",
    image: { src: siteImages.junior.src, alt: siteImages.junior.alt },
  },
  sandtrap: {
    visible: true,
    eyebrow: "The Sand Trap",
    title: "Stay for Breakfast, Lunch, Dinner, and Drinks",
    copy:
      "After the round, settle into warm clubhouse hospitality with classic breakfast favorites, satisfying lunch options, dinner service, and drinks throughout the week.",
    buttonLabel: "Visit The Sand Trap",
    buttonHref: "/the-sand-trap",
    image: { src: siteImages.dining.src, alt: siteImages.dining.alt },
  },
  life: {
    visible: true,
    eyebrow: "Life at Redland",
    title: "A Course, a Restaurant, and a South Florida Gathering Place",
    images: homeContent.lifeAtRedland.map((i) => ({ src: i.src, alt: i.alt, label: i.label })),
  },
  finalCta: {
    visible: true,
    eyebrow: "Tee Times",
    title: homeContent.finalCta.title,
    note: "Use 305-247-8503, extension 1 for tee times and Pro Shop questions.",
    image: { src: siteImages.heroFairway.src, alt: siteImages.heroFairway.alt },
    buttons: [
      { label: "Call the Pro Shop", href: contact.phoneHref, variant: "light" },
      { label: "Book a Tee Time", href: booking.href, variant: "secondary" },
      { label: "View Rates", href: "/rates", variant: "secondary" },
    ],
  },
};

export const contactReasons = [
  "Tee Time",
  "Membership",
  "Junior Golf",
  "Junior Camp",
  "The Sand Trap",
  "Golf Event",
  "General Question",
];

export const seo = {
  siteTitle: "Redland Golf & Country Club | Homestead, Florida",
  homeDescription:
    "Experience 18 holes of South Florida golf at Redland Golf & Country Club in Homestead. Explore public rates, memberships, events, junior programs, and The Sand Trap.",
};

export const membershipDocuments = {
  information: { url: "/documents/membership-2025.pdf", fileName: "2025 Membership.pdf" },
  agreement: {
    url: "/documents/new-member-agreement.docx",
    fileName: "New Member Agreement.docx",
    pdfUrl: "/documents/new-member-agreement.pdf",
    pdfFileName: "New Member Agreement.pdf",
  },
  application: { url: "/documents/membership-application.xlsx", fileName: "Membership Appliction - Updates.xlsx" },
};
